import { render, staticRenderFns } from "./SidebarFooter.vue?vue&type=template&id=0b607baa&scoped=true"
import script from "./SidebarFooter.vue?vue&type=script&lang=ts"
export * from "./SidebarFooter.vue?vue&type=script&lang=ts"
import style0 from "./SidebarFooter.vue?vue&type=style&index=0&id=0b607baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b607baa",
  null
  
)

export default component.exports